import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const About = () => {
  return (
    <div>
      <PageHeader 
        title="ABOUT US"
        subtitle="Our Promise, Our People, Our Purpose"
        backgroundImage="/images/aboutbg.png"
      />
      <div className="page-content">
        <div className="container">
          {/* Centered Introduction Section */}
          <div className="about-intro">
            <h2>Our Promise, Our People, Our Purpose</h2>
            <p>At MindXchange, we are your trusted business partner. As a leading-edge business consulting company, we specialize in digital strategy, process re-engineering, data analytics, automation, and enterprise technology solutions across industries to increase transformational results.</p>
            <p>We focus on delivering distinct business value that will empower you to fulfill your unique challenges and meet your goals. Our processes: straightforward and objective; our vision: strategic and measurable; our approach: collaborative and results-oriented. We work with you to overcome traditional challenges and explore new possibilities through smart thinking.</p>
          </div>

          {/* Left-aligned content with Approach.png */}
          <div className="about-section">
            <div className="about-content-left">
              <div className="about-text">
                <h2>Our Approach</h2>
                <p>Client success and transparency are at the core of everything we do. Whether you're seeking product development, technology transformation, or process consulting, our core services are delivering dynamic, scalable solutions that ensure team success and eliminate the uncertainty of planning operations and creating a better way to work with confidence.</p>
              </div>
              <div className="about-image">
                <img src="/images/Approach.png" alt="Our Approach" />
              </div>
            </div>
          </div>

          {/* Right-aligned content with Apart.png */}
          <div className="about-section">
            <div className="about-content-right">
              <div className="about-image">
                <img src="/images/Apart.png" alt="What Sets Us Apart" />
              </div>
              <div className="about-text">
                <h2>What Sets Us Apart</h2>
                <p>At MindXchange, diversity brings out our greatest strength, not just in our team building and innovative solutions to deliver exceptional outcomes. This commitment to inclusivity and synergy ensures every client receives unique perspectives and industry insights that help make our clients even better.</p>
              </div>
            </div>
          </div>

          {/* Left-aligned content with Promise.png */}
          <div className="about-section">
            <div className="about-content-left">
              <div className="about-text">
                <h2>Our Promise</h2>
                <p>When you work with MindXchange, you're not just getting process, technology, or consulting services. We're committed to advancing your business vision and expansion in line with the power of tomorrow and strategy. We become a trusted part of your business, working together. Contact MindXchange today to begin your journey towards smarter, stronger business.</p>
              </div>
              <div className="about-image">
                <img src="/images/Promise.png" alt="Our Promise" />
              </div>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <p style={{ marginBottom: '1rem' }}>Ready to get started?</p>
            <Link to="/contact" className="hero-btn">Get Started Today</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 